var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sammio-actions'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('section',{staticClass:"col-md-8 my-5",attrs:{"id":"sammio__element--main"}},[_c('div',{staticClass:"mb-5",domProps:{"innerHTML":_vm._s(_vm.infoContent)}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }